import React from 'react'
import { Link } from 'react-router-dom'

export default function Accommodation() {
  return (
    <>
      <section className='accommodation-area'>
        <img src='/image/jimcorbett-rooms.webp' className='img-responsive' alt='Rooms' />

        <div className='container'>
          <div className='row justify-content-end'>
            <div className='col-lg-6 col-md-6'>
              <div className='accom-room-box wow animate__animated animate__fadeInUp'>
                <h1 className='heading'>Rooms & Private Cottages</h1>
                <p>Whether you’re looking for a romantic hideaway in our Club Cottages with private Jacuzzis or a basecamp for the whole crew in our Family Cottages, we have a space that feels like home. From pet-friendly Luxury Cottages to rooms featuring deep bathtubs, our accommodations are built for genuine comfort. We’ve used warm textures and natural finishes to ensure your stay is as relaxing as the wilderness surrounding it.</p>

                <Link to="/resort-de-coracao-corbett/room-listing" className="arrow-butn">
                  View Corbett Rooms <img src="/image/right-arrow.svg" alt="arrow" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className='jimcorbett-explore'>
        <img src='/image/jimcorbett-explore.webp' className='img-responsive' alt='Rooms' />

        <div className='container'>
          <div className='row'>
            <div className='col-lg-6 col-md-6'>
              <div className='jimcorbett-explore-box wow animate__animated animate__fadeInUp'>
                <h2 className='heading'>Explore the Wild</h2>
                <p>The untamed beauty of Corbett is right at our doorstep. Step outside to discover quiet forest trails, riverside escapes, and the thrill of a morning safari. Whether you’re looking for a peaceful moment of reflection by the water or a soulful adventure through the tiger territory, we curate outdoor experiences that help you truly connect with the local culture and the vibrant wildlife of the region.</p>

                <Link to="/offer-listing" className="arrow-butn">
                  Explore All <img src="/image/right-arrow.svg" alt="arrow" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className='accommodation-area'>
        <img src='/image/jimcorbett-rejuvenation-retreat.webp' className='img-responsive' alt='Rooms' />

        <div className='container'>
          <div className='row justify-content-end'>
            <div className='col-lg-6 col-md-6'>
              <div className='accom-room-box wow animate__animated animate__fadeInUp'>
                <h3 className='heading'>The Rejuvenation Retreat</h3>
                <p>Our Rejuvenation Retreat is your personal sanctuary for finding balance after a day of exploration. In a setting where wellness is inspired by the stillness of nature, you can indulge in soothing massages and mindful practices that clear the mind. We’ve designed our therapies to do more than just relax your body—they are here to renew your spirit and help you return home feeling completely revitalized.</p>

                <Link to="/resort-de-coracao-corbett/spa-wellness" className="arrow-butn">
                  Experience Wellness <img src="/image/right-arrow.svg" alt="arrow" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className='jimcorbett-explore'>
        <img src='/image/jimcorbett-culinary-house.webp' className='img-responsive' alt='Rooms' />

        <div className='container'>
          <div className='row'>
            <div className='col-lg-6 col-md-6'>
              <div className='jimcorbett-explore-box wow animate__animated animate__fadeInUp'>
                <h4 className='heading'>The Culinary House</h4>
                <p>Dining at Ice and Spice is where world-class flavors meet the rustic charm of the forest. Our chefs bring passion to every plate, serving up a mix of global classics and regional Kumaoni favorites. Whether you are enjoying a slow breakfast on the sun deck or a grilled feast at our open-air kitchen, every meal is crafted to be a highlight of your journey, fresh, flavorful, and completely soul-satisfying.</p>

                <Link to="/resort-de-coracao-corbett/cuisine" className="arrow-butn">
                  Explore Dining <img src="/image/right-arrow.svg" alt="arrow" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
